import { render, staticRenderFns } from "./heat.vue?vue&type=template&id=396d2dc0&scoped=true"
import script from "./heat.vue?vue&type=script&lang=js"
export * from "./heat.vue?vue&type=script&lang=js"
import style0 from "./heat.vue?vue&type=style&index=0&id=396d2dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396d2dc0",
  null
  
)

export default component.exports